import React, { useEffect, useState } from "react";
import { Switch, Tooltip } from "@material-ui/core";

import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";

const getIconStyle = (type) => ({
  backgroundColor: type === "check" ? "#70CD6C" : "#F07E7E",
  borderRadius: "50%",
  color: "#3b3b3b",
  fontSize: 20,
});

const STORAGE_KEY = "ModeOpenTabsOn";
const OPEN_EDIT_TABS_KEY = "openEditTabs";

const OpenTabsSwitch = () => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    setChecked(saved === "true");
  }, []);

  const handleChange = (event) => {
    const value = event.target.checked;
    setChecked(value);
    localStorage.setItem(STORAGE_KEY, value.toString());

    if (!value) {
      // Quando lo switch diventa false, rimuovi openEditTabs
      localStorage.removeItem(OPEN_EDIT_TABS_KEY);
    }

    window.location.reload();
  };

  return (
    <Tooltip title="Modalità schede multiple">
      <Switch
        checked={checked}
        onChange={handleChange}
        color="default"
        icon={<CloseIcon style={getIconStyle("close")} />}
        checkedIcon={<CheckIcon style={getIconStyle("check")} />}
      />
    </Tooltip>
  );
};

export default OpenTabsSwitch;
